<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefw"><a id="ch01"></a><a id="page_1"></a><a class="nounderb" href="#/xhtml/cont#cont"><img alt="image" class="imagefw" src="images/f0001-01.jpg"/></a></p>
<p class="noindent1"><span class="big">E</span>arly in the morning, Melli the Caramel Fairy
            flew to the top of Caramel Hills. She was checking on the caramel chocolate rolls she
            had made with her Chocolate Fairy friend Cocoa. Melli smiled at their newest creation
            drying in the cool shade of a caramel tree. Yesterday the two fairies had worked hard
            rolling small logs <a id="page_2">of caramel and then dipping them in chocolate. The
            final touch was a drizzle of butterscotch on top. Melli couldn’t wait to taste
            one!</a></p><a id="page_2">
<p class="indent">A caramel turtle jutted his head out of his shell and smelled the fresh
            candy. Melli laughed. “You were hiding over by that log,” she said to the
            turtle. She kneeled down next to him. “Did you think you’d snatch a candy
            without my noticing?”</p>
<p class="indent">The turtle quickly slipped his head back into his shell. Still as a rock,
            he waited to see what the Caramel Fairy would do.</p>
<p class="indent">Melli placed one of the candies in front of him. “Of course you may
            have one,” she said sweetly. “There’s enough to share.”</p>
<p class="indent">The turtle stuck his head out again and gobbled it up.</p>
</a><p class="indent"><a id="page_2"></a><a id="page_3">“Do you like the candy?” Melli asked.</a></p><a id="page_3">
<p class="indent">The turtle nodded, and Melli smiled. “Cocoa and I are going to bring
            these to Sun Dip this evening,” she said.</p>
<p class="indent">Sun Dip was the time at the end of the day when the sun set behind the
            Frosted Mountains and the Candy Fairies relaxed. Melli loved visiting with her friends
            and catching up on everyone’s activities. And today she and Cocoa would bring
            their new candy. She hoped her friends would enjoy the sweet treat.</p>
<p class="indent">Just as Melli was putting the candies in her basket, she heard a squeal.
            It sounded like an animal in trouble. She put the basket down and walked toward the
            sound.</p>
<p class="indent">“Hot caramel!” Melli cried as she peered around one of the
            caramel trees.</p>
</a><p class="indent"><a id="page_3"></a><a id="page_4">Lying on the ground was a small caramella bird. He was
            trying to flap his wings to fly, but they were barely moving. Melli leaned in closer and
            noticed that the bird’s feathers were wet and stuck together.</a></p><a id="page_4">
<p class="indent">Melli reached out to the bird. “You poor thing,” she
            whispered. She tried to calm the little one by talking to him. Caramella birds lived in
            the valley of Caramel Hills and had bright yellow wing feathers. They lived off the
            seeds of the caramel trees and filled the hills with their soft chirps.</p>
</a><p class="indent"><a id="page_4">“Where have you been playing?” Melli asked sweetly. She
            carefully picked up the bird and gently stroked his head. Immediately she realized that
            his feathers were covered in thick butterscotch. “How did you get coated in this
                </a><a id="page_5">syrup?” she asked. “No wonder you can’t move or
            fly.”</a></p><a id="page_5">
<p class="indent">The bird chirped loudly. It was shaking in her hands.</p>
<p class="indent">“Butterscotch is not the best thing for feathers,” Melli said,
            smiling at the tiny caramella. “Don’t worry, sweetie,” she added
            softly. “Let’s give you a good bath and get this mess off your wings. I know
            all about sticky caramel.” She patted the bird’s head gently. “I will
            get you cleaned up in no time. Let’s go to the water well and rinse you
            off.”</p>
</a><p class="indent"><a id="page_5">Melli held on to the bird and flew to the edge of Caramel Hills. The tiny
            creature seemed to relax in Melli’s hands, but his heart was still pounding. At
            the well Melli began to wash the butterscotch off the bird’s wings. She knew
            she’d have to spend some time scrubbing. She </a><a id="page_6">had gotten caramel
            on her clothes before, and it often took a while to get all the goo off.</a></p><a id="page_6">
<p class="indent">After a few rinses Melli began to see his brightly colored feathers.</p>
<p class="indent">“There, that does it,” she said, feeling satisfied. She stood
            back and looked at the little bird. “You do have gorgeous yellow wings!”</p>
<p class="indent">The bird shook the water off his wings. He was happy to be able to move
            them freely. He bowed his head to Melli, thanking her for helping him.</p>
<p class="indent">“You should be able to fly now,” Melli said. “Be
            careful, and stay away from the sticky stuff!”</p>
<p class="indent">“Hi, Melli!” Cocoa appeared next to her. “What are you
            doing here?”</p>
</a><p class="indent"><a id="page_6">“Cocoa,” Melli gasped. “You scared me! I didn’t
            see you there.” She pointed to the caramella bird. </a><a id="page_7">“Look
            who I found. He was covered in butterscotch, and his wings were stuck together. I just
            gave him a bath with the fresh well water.”</a></p><a id="page_7">
<p class="indent">Cocoa’s wings fluttered. “Oh, bittersweet chocolate,”
            she said sadly. “This is worse than I thought.”</p>
<p class="indent">“What are you talking about?” Melli asked. “He’s
            all clean now. He’ll be able to fly.”</p>
<p class="indent">“It’s not only this bird I am worried about,” Cocoa
            said. “I heard from a sugar fly that there was a butterscotch syrup spill on the
            eastern side of Butterscotch Volcano. That must be where this one got syrup on his
            wings. <span class="txit">All</span> the caramella birds are in danger!”</p>
<p class="indent">“Oh no,” Melli said. “So many caramella birds live over
            there. What else did the sugar fly tell you?”</p>
</a><p class="imagefp"><a id="page_7"></a><a id="ch01a"></a><a id="page_8"><img alt="image" class="imagefp" src="images/f0008-01.jpg"/></a></p><a id="page_8">
</a><p class="indent"><a id="page_8"></a><a id="ch01b"></a><a id="page_9">“That was all,” Cocoa
            replied.</a></p><a id="page_9">
<p class="indent">Sugar flies passed information around Sugar Valley. If a fairy wanted to
            get the word out about something important, the sugar flies were the ones to spread the
            news.</p>
<p class="indent">“Let’s go now,” Melli said urgently. “If
            Butterscotch Volcano erupts, there’ll be a large spill in the hills.” She
            looked down at the bird. “Is that what happened to you? Will you take us to where
            you got butterscotch on your wings?”</p>
<p class="indent">The bird took flight, and Melli and Cocoa trailed after him. His yellow
            feathers gleamed in the sunlight. Melli beat her wings faster. She was very concerned
            about what kind of sticky mess they were going to find.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?ef3b40b6